import React from 'react';
import styled  from 'styled-components';
import Win3 from '../datasets/index-leadership-card';
import Win2 from '../datasets/institutional-health-card';
import Win1 from '../datasets/web-traffic';

const StyledComp = styled.div`
position: relative;
width: 100%;
height: calc(100% - 60px);
overflow: hidden;
display: flex;
flex-direction: row;
background-image: url('/product_images/11.webp');
background-size: cover;

.win{
  position: absolute;
  top: 24px;
  left: 24px;
  width: 100%;

  > section, > div{
    min-width: 80%;
    width: 80%;
    max-width: 80%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

    &.w2{
      top: 96px;
      left: 96px;
    }
    &.w3{
      top: 168px;
      left: 168px;
    }

  }
}

`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="win w1">
        <Win1 />
      </div>
      <div className="win w2">
        <Win2 />
      </div>
      <div className="win w3">
        <Win3 />
      </div>
    </StyledComp>
  );
};

export default Comp;
